module.exports = __webpack_public_path__ + "img/errorMessage.2def7369.png";